import React from "react";
import { Row, Col, Card, Tooltip } from "antd";
import {
  WarningOutlined,
  CarOutlined,
  DollarOutlined,
  CalendarOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";

const StatGroup = ({ title, dailyStats, monthlyStats, icon, color }) => {
  // Calculate percentage change
  const calculateChange = (current, previous) => {
    if (!previous) return 0;
    return ((current - previous) / previous) * 100;
  };

  return (
    <Col xs={24} md={8}>
      <Card
        className="hover:shadow-lg transition-shadow"
        title={
          <div className="flex items-center gap-2">
            <span style={{ color }}>{icon}</span>
            <span>{title}</span>
          </div>
        }
      >
        <div className="space-y-4">
          {/* Daily Stats */}
          <div className="flex items-center justify-between">
            <div>
              <div className="text-sm text-gray-500">Aujourd'hui</div>
              <div className="text-2xl font-bold">{dailyStats.value}</div>
            </div>
            <div className="text-right">
              {dailyStats.previousValue && (
                <div
                  className={`flex items-center gap-1 text-sm ${
                    calculateChange(
                      dailyStats.value,
                      dailyStats.previousValue
                    ) >= 0
                      ? "text-green-500"
                      : "text-red-500"
                  }`}
                >
                  {calculateChange(
                    dailyStats.value,
                    dailyStats.previousValue
                  ) >= 0 ? (
                    <ArrowUpOutlined />
                  ) : (
                    <ArrowDownOutlined />
                  )}
                  {Math.abs(
                    calculateChange(dailyStats.value, dailyStats.previousValue)
                  ).toFixed(1)}
                  %
                </div>
              )}
              <div className="text-xs text-gray-400">vs. hier</div>
            </div>
          </div>

          {/* Monthly Stats */}
          <div className="flex items-center justify-between pt-2 border-t">
            <div>
              <div className="text-sm text-gray-500">Ce mois</div>
              <div className="text-2xl font-bold">{monthlyStats.value}</div>
            </div>
            <div className="text-right">
              {monthlyStats.previousValue && (
                <div
                  className={`flex items-center gap-1 text-sm ${
                    calculateChange(
                      monthlyStats.value,
                      monthlyStats.previousValue
                    ) >= 0
                      ? "text-green-500"
                      : "text-red-500"
                  }`}
                >
                  {calculateChange(
                    monthlyStats.value,
                    monthlyStats.previousValue
                  ) >= 0 ? (
                    <ArrowUpOutlined />
                  ) : (
                    <ArrowDownOutlined />
                  )}
                  {Math.abs(
                    calculateChange(
                      monthlyStats.value,
                      monthlyStats.previousValue
                    )
                  ).toFixed(1)}
                  %
                </div>
              )}
              <div className="text-xs text-gray-400">vs. mois dernier</div>
            </div>
          </div>
        </div>
      </Card>
    </Col>
  );
};

const EnhancedStatistics = ({ dashboardData }) => {
  return (
    <Row gutter={[16, 16]}>
      <StatGroup
        title="Avertissements"
        icon={<WarningOutlined />}
        color="orange"
        dailyStats={{
          value: dashboardData.dailyWarnings,
          previousValue: dashboardData.previousDailyWarnings,
        }}
        monthlyStats={{
          value: dashboardData.monthlyWarnings,
          previousValue: dashboardData.previousMonthlyWarnings,
        }}
      />
      <StatGroup
        title="Infractions"
        icon={<CarOutlined />}
        color="#cf1322"
        dailyStats={{
          value: dashboardData.dailyInfractions,
          previousValue: dashboardData.previousDailyInfractions,
        }}
        monthlyStats={{
          value: dashboardData.monthlyInfractions,
          previousValue: dashboardData.previousMonthlyInfractions,
        }}
      />
      <StatGroup
        title="Revenus"
        icon={<DollarOutlined />}
        color="#3f8600"
        dailyStats={{
          value: dashboardData.dailyRevenue,
          previousValue: dashboardData.previousDailyRevenue,
        }}
        monthlyStats={{
          value: dashboardData.monthlyRevenue,
          previousValue: dashboardData.previousMonthlyRevenue,
        }}
      />
    </Row>
  );
};

export default EnhancedStatistics;
